// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BjQOL","colMin":"styles_colMin__2rSkx"};